import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import colors from '@shared/design-tokens/colors';

import { displayTypes, justifyTypes, alignTypes } from './types';

import {
  wrapperCSS,
  labelCSS,
  flexWrapperCSS,
  conatinerCSS,
  constcolumnCSS,
} from './styled';

export {
  displayTypes,
  justifyTypes,
  alignTypes,
};

export const mediaBreakpoints = {
  smallPhone: 320,
  phone: 576,
  // smallTablet: 768,
  tablet: 768,
  laptop: 992,
  desktop: 1200,
};

export const tabletAndUp = ({ desktopWidth }) => ({ width: desktopWidth });

export const ColumnWrapper = styled.div`
  ${wrapperCSS}
`;

export const Label = styled.div`
  ${labelCSS}
`;

export const RowWrapper = styled.div`
  ${flexWrapperCSS}
`;

export const ieCSS = (...args) => css`
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    ${css(...args)}
  }
`;

/**
 * MediaQueries for Main/Base components.
 */

export const media = {
  smallPhone: (...args) => css`
    @media (min-width: 320px) {
      ${css(...args)}
    }
  `,
  phone: (...args) => css`
    @media (min-width: 576px) {
      ${css(...args)}
    }
  `,
  tablet: (...args) => css`
    @media (min-width: 768px) {
      ${css(...args)}
    }
  `,
  laptop: (...args) => css`
    @media (min-width: 992px) {
      ${css(...args)}
    }
  `,
  desktop: (...args) => css`
    @media (min-width: 1200px) {
      ${css(...args)}
    }
  `,

  maxWidthPhone: (...args) => css`
    @media (max-width: 576px) {
      ${css(...args)}
    }
  `,
  maxWidthTablet: (...args) => css`
    @media (max-width: 768px) {
      ${css(...args)}
    }
  `,
  maxWidthLargeTablet: (...args) => css`
  @media (max-width: 1024px) {
    ${css(...args)}
  }
  `,
  maxWidthLaptop: (...args) => css`
    @media (max-width: 992px) {
      ${css(...args)}
    }
  `,
  maxWidthDesktop: (...args) => css`
    @media (max-width: 1200px) {
      ${css(...args)}
    }
  `,
};

export const mediaCSS = {
  smallPhone: (_css) => css`
    @media (min-width: 320px) {
      ${_css}
    }
  `,
  phone: (_css) => css`
    @media (min-width: 576px) {
      ${_css}
    }
  `,
  tablet: (_css) => css`
    @media (min-width: 768px) {
      ${_css}
    }
  `,
  laptop: (_css) => css`
    @media (min-width: 992px) {
      ${_css}
    }
  `,
  desktop: (_css) => css`
    @media (min-width: 1200px) {
      ${_css}
    }
  `,

  maxWidthSmallPhone: (_css) => css`
    @media (max-width: 320px) {
      ${_css}
    }
  `,

  maxWidthPhone: (_css) => css`
    @media (max-width: 576px) {
      ${_css}
    }
  `,
  maxWidthTablet: (_css) => css`
    @media (max-width: 768px) {
      ${_css}
    }
  `,
  maxWidthStandardTablet: (_css) => css`
    @media (max-width: 834px) {
      ${_css}
    }
  `,
  maxWidthLaptop: (_css) => css`
    @media (max-width: 992px) {
      ${_css}
    }
  `,
  maxWidthLargeTablet: (_css) => css`
  @media (max-width: 1024px) {
    ${_css}
  }
`,
  maxWidthDesktop: (_css) => css`
    @media (max-width: 1200px) {
      ${_css}
    }
  `,
};

/**
 * Layouts for Main/Base components.
 */

export const Container = styled.div`
  ${conatinerCSS}
  
  ${media.phone({
    'max-width': '540px',
  })}

  ${media.tablet({
    'max-width': '720px',
  })}

  ${media.laptop({
    'max-width': '960px',
  })}

  ${media.desktop({
    'max-width': '1140px',
  })}
`;

export const Row = styled.div`
  display: ${displayTypes.flex};
  ${({ alignItems }) => alignItems && ({ 'align-items': alignItems })}
  ${({ justifyContent }) => justifyContent && ({ 'justify-content': justifyContent })}
  ${({ flexGrow }) => flexGrow && ({ 'flex-grow': `${flexGrow}` })}

  ${({ margin }) => margin && ({ margin })}
  ${({ padding }) => padding && ({ padding })}

  flex-wrap: wrap;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }

  button, .button {
    margin: 0px 10px 0px 0px;
    ${media.maxWidthPhone({ margin: '0px 0px 10px 0px' })}
  }

  svg {
    display: ${displayTypes.block};
  }

  ${({ flexWrap }) => flexWrap && ({ 'flex-wrap': `${flexWrap} !important` })}
`;

Row.propTypes = {
  flexWrap: PropTypes.oneOf(['wrap', 'nowrap']),
  alignItems: PropTypes.oneOf(Object.values(alignTypes)),
  justifyContent: PropTypes.oneOf(Object.values(justifyTypes)),
  flexGrow: PropTypes.oneOf([1, 2, 3]),

  margin: PropTypes.string,
  padding: PropTypes.string,
};

Row.defaultProps = {
  flexWrap: undefined,
  alignItems: alignTypes.stretch,
  justifyContent: justifyTypes.flexStart,
  flexGrow: undefined,

  margin: '0px',
  padding: '0px',
};

export const centerIcons = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ cursorIsPointer }) => cursorIsPointer && { cursor: 'pointer' }}
`;

export const hideScrollbar = css`
  /* Hide scrollbar for Chrome, Safari and Opera */
  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .hide-scroll {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

export const unselectable = css`
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
  -o-user-select: none;
  -moz-user-select: none;
  pointer-events: none;
`;

const flexWidthWrapper = (flex) => (`0 0 ${flex}%`);

const wrapKvP = (key, value) => (key + value);
export const FlexItem = styled.div`
  ${({ display }) => display && ({ display })}
  ${({ flexGrow }) => flexGrow && ({ 'flex-grow': `${flexGrow}` })}
  ${({ flex }) => flex && ({ flex: `${flex}` })}
  ${({ flexOrder }) => flexOrder && ({ order: flexOrder })}
  ${({ margin }) => margin && ({ margin })}
  ${({ padding }) => padding && ({ padding })}
  ${({ alignItems }) => alignItems && ({ 'align-items': alignItems })}
  ${({ responsiveMargin }) => responsiveMargin?.mobile && ({ margin: responsiveMargin.mobile })}
  ${({ responsiveMargin }) => responsiveMargin?.tablet && media.tablet({
    margin: responsiveMargin.tablet,
  })}
  ${({ responsiveMargin }) => responsiveMargin?.desktop && media.desktop({
    margin: responsiveMargin.desktop,
  })}

  @media (min-width: 576px) {
    ${({ flexWidth }) => flexWidth && ({ flex: flexWidthWrapper(flexWidth) })}
  }
`;

FlexItem.propTypes = {
  display: PropTypes.oneOf(Object.values(displayTypes)),
  flexGrow: PropTypes.oneOf([1, 2, 3]),
  flex: PropTypes.string,
  flexOrder: PropTypes.number,
  flexWidth: PropTypes.number,

  margin: PropTypes.string,
  padding: PropTypes.string,
  responsiveMargin: PropTypes.shape({
    mobile: PropTypes.string,
    tablet: PropTypes.string,
    desktop: PropTypes.string,
  }),
  alignItems: PropTypes.oneOf(Object.values(alignTypes)),
};

FlexItem.defaultProps = {
  display: 'flex',
  flexGrow: undefined,
  flex: undefined,
  flexOrder: undefined,
  flexWidth: undefined,

  margin: '0px',
  padding: '0px',
  responsiveMargin: null,
  alignItems: null,
};

export const Column = styled(FlexItem)`
  ${constcolumnCSS}
  ${({ alignItems }) => alignItems && ({ 'align-items': alignItems, 'text-align': alignItems })}
  ${({ justifyContent }) => justifyContent && ({ 'justify-content': justifyContent })}
  ${({ flexGrow }) => flexGrow && ({ 'flex-grow': `${flexGrow}` })}

  svg {
    display: ${displayTypes.block};
  }
`;

Column.propTypes = {
  flexGrow: PropTypes.oneOf([1, 2, 3]),

  alignItems: PropTypes.oneOf(Object.values(alignTypes)),
  justifyContent: PropTypes.oneOf(Object.values(justifyTypes)),
};

Column.defaultProps = {
  flexGrow: undefined,

  alignItems: alignTypes.stretch,
  justifyContent: justifyTypes.flexStart,
};

export const Card = styled.div`
  border-radius: 8px 8px 8px 8px;
  border: 1px solid ${colors.gray6};
  ${({ hasShadow }) => hasShadow && { boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.16)' }}
  ${({ maxWidth }) => maxWidth && { 'max-width': maxWidth }}
`;

Card.propTypes = {
  hasShadow: PropTypes.bool,
};

Card.defaultProps = {
  hasShadow: false,
};

export const Block = styled.div`
  ${({ margin }) => margin && ({ margin })}
  ${({ padding }) => padding && ({ padding })}
  ${({ color }) => color && ({ 'background-color': color })}
`;

Block.propTypes = {
  margin: PropTypes.string,
  padding: PropTypes.string,
};

Block.defaultProps = {
  margin: '0px',
  padding: '0px',
};

const gridDesktop = `
  .grid-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }

  .float-right {
    float: right;
  }

  .float-left {
    float: left;
  }
`;

export const grid = css`
  ${mediaCSS.phone(gridDesktop)}
`;

/**
 * Flex5050
 */

export const FlexItem50 = styled(FlexItem)`
  flex: 0 0 100%;
  @media (min-width: 768px) {
    flex: 0 0 50%;
  }
  @media (max-width: 768px) {
    order: ${({ mobileOrder }) => mobileOrder || ''};
  }
`;

FlexItem50.propTypes = {
  mobileOrder: PropTypes.oneOf([1, 2]).isRequired,
};

/**
 * Flex 1/3
 */

export const FlexItem33 = styled(FlexItem)`
  flex: 0 0 100%;
  @media (min-width: 768px) {
    flex: 0 0 33.3333%;
  }
  @media (max-width: 768px) {
    order: ${({ mobileOrder }) => mobileOrder || ''};
  }
`;

FlexItem33.propTypes = {
  mobileOrder: PropTypes.oneOf([1, 2]).isRequired,
};

export const ColoredBlock = styled.div`
  height: 100%;
  width: 100%;

  & > * {
    ${media.tablet({ height: '100%' })}
  }
  
  ${({ hw }) => hw && ({ height: wrapKvP(hw, 'px'), width: wrapKvP(hw, 'px') })}

  ${({ height }) => height && ({ height: wrapKvP(height, 'vh') })}
  ${({ width }) => width && ({ width: wrapKvP(width, 'vw') })}
  ${({ color }) => color && ({ 'background-color': color })}
`;

export const getMargin = (top = 0, right = 0, bottom = 0, left = 0) => (
  `margin: ${top}px ${right}px ${bottom}px ${left}px;`
);

export const getPadding = (top = 0, right = 0, bottom = 0, left = 0) => (
  `padding: ${top}px ${right}px ${bottom}px ${left}px;`
);

export const getBorderRadius = (topLeft = 0, topRight = 0, bottomRight = 0, bottomLeft = 0) => ({
  'border-top-left-radius': `${topLeft}px`,
  'border-top-right-radius': `${topRight}px`,
  'border-bottom-right-radius': `${bottomRight}px`,
  'border-bottom-left-radius': `${bottomLeft}px`,
});

const standardBorder = (value) => `${value}px solid ${colors.gray6}`;
export const getBorder = (top = 0, right = 0, bottom = 0, left = 0) => ({
  'border-top': standardBorder(top),
  'border-right': standardBorder(right),
  'border-bottom': standardBorder(bottom),
  'border-left': standardBorder(left),
});

export const StorybookWrapper = styled.div`
  .main-container {
    background: lightpink;
  } 
`;

export const RequiredSpan = styled.span`
  color: ${colors.core.coral};
  margin-left: 5px;
`;

export const Overlay = styled(Block)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  overflow-y: scroll;
  max-height: 100vh;
  background-color: ${colors.modalBackdrop};
  display: flex;
  z-index: 999;
  flex-direction: column;
  align-items: center;
`;
